import { jsx } from 'react/jsx-runtime';

const SvgActionEditCircleFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 22c5.51 0 10-4.49 10-10S17.51 2 12 2 2 6.49 2 12s4.49 10 10 10Zm3-15 2 2-1.41 1.41-2-2L15 7Zm-7.5 7.5 5.03-5.03 2 2L9.5 16.5h-2v-2Z" }) }));

export { SvgActionEditCircleFill as default };
//# sourceMappingURL=ActionEditCircleFill.es.js.map
